module.exports = __webpack_public_path__ + "static/media/canada.5d08ccab.svg";